import React, { useMemo } from 'react';
import Accordion from 'components/Accordion';
import useCulture from 'hooks/Meteorology/Agro/WaterBalanceCulture/DetailedView/useCulture';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';
import Button from 'components/DesignSystem/Button';

export default function Culture() {
  const { availableCultures, selectedCulture, setCulture } = useCulture();
  const closeAccordion = useMemo(() => buildAccordionClickFunction('culture-accordion'), []);

  return (
    <Accordion.Item eventKey="culture" id="culture-accordion">
      <Accordion.Header>Cultura</Accordion.Header>
      <Accordion.Body>
        { availableCultures?.map((culture) => (
          <Button
            key={culture.id}
            type="tertiary"
            onClick={() => { setCulture(culture.id); closeAccordion(); }}
            className={`w-100 btn-control-panel ${selectedCulture === culture.id ? 'btn-control-panel-active' : ''}`}
          >
            {culture.label}
          </Button>
        ))}
      </Accordion.Body>
    </Accordion.Item>
  );
}
